module.exports = __webpack_public_path__ + "img/suby.cc654bc.svg";